<template>
  <div>
      <div class="sidebar-box white animate-onscroll">
            <h3>新闻动态</h3>
            <ul class="upcoming-events">
                <!-- Event -->
                <li v-for="(article,index) in articles" :key="index">
                    <div class="date" >
                        <span>
                            <span class="day">{{getDay(article)}}</span>
                            <span class="month">{{getMonth(article)}}</span>
                        </span>
                    </div>
                    <div class="event-content">
                        <h6><router-link :to="`/news/info/${plateId}/${article._id}`">{{article.title}}</router-link></h6>
                    </div>
                </li>
            </ul>
            <router-link :to="`/news/views/${plateId}`" class="button transparent button-arrow">更多</router-link>
        </div>
        <div class="sidebar-box image-banner animate-onscroll ">
            <router-link to="/">
                <h3 style="padding-top: 14px;">证书展示</h3>
                <span class="button transparent button-arrow" @click="scrollTo('zhengshu',global.isPhone()?-10: -100)">点击查询</span>
                <div class="ps-img">
                    <p class="tc mt5"><img :src="`${global.remoteIp}/uploads/${webConfigs.certificatefront}`" alt=""></p>
                    <p class="tc "><img :src="`${global.remoteIp}/uploads/${webConfigs.certificateback}`" alt=""></p>
                </div>
            </router-link>
        </div>
        <div class="sidebar-box image-banner animate-onscroll animate-onscroll">
            <a>
                <h3 style="padding-top: 14px;">在线留言</h3>
                <div style="padding:10px 15px;">
                    <el-form :model="form" :rules="rules" ref="msgForm">
                      <el-form-item >
                        <el-input v-model="form.name"  placeholder="在此输入您姓名！"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input v-model="form.phone" placeholder="在此输入您的电话号码！"></el-input>
                      </el-form-item>
                      <el-form-item >
                        <el-input v-model="form.content" rows=4 type="textarea" show-word-limit  maxlength="100"  placeholder="在此输入您的留言，我们会尽快与您联系！"></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                <span class="button transparent button-arrow" @click="submitForm('msgForm')">提交</span>
            </a>
        </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import { Message } from "element-ui";
export default {
  props: {
    plates: Array,
    webConfigs: Object,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
      cert1src: "",
      cert2src: "",
      adv: null,
      form: {
        name: "",
        content: "",
        phone: "",
        yzmsrc: "",
        yzcode: "",
      },
      formLabelWidth: "60px",
      rules: {},
    };
  },

  created() {},

  methods: {
    getDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return now.getDate();
    },
    getMonth(article) {
      var arrMonths = [
        "Jan.",
        "Feb.",
        "Mar.",
        "Apr.",
        "May.",
        "Jun.",
        "Jul.",
        "Aug.",
        "Sep.",
        "Oct.",
        "Nov",
        "Dec.",
      ];
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return arrMonths[now.getMonth() + 1];
    },
    getImgVerify() {
      console.log("getImgVerify");
      this.form.yzmsrc =
        `${this.global.remoteIp}/api/leaveMessages/getLeaveMessagesImgVertify` +
        "?" +
        Math.random();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post("/api/leaveMessages", this.form).then((res) => {
            // 登录成功
            this.dialogFormVisible = false;
            this.form = {};
            Message.success({ message: "留言成功", offset: 100 });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    scrollTo(id, offset) {
      offset = offset || -10;
      var el = document.getElementById(id);
      this.$nextTick(function() {
        window.scrollTo({
          behavior: "smooth",
          top: el.offsetTop + offset,
        });
      });
    },
  },

  computed: {},

  mounted() {
    for (let j = 0; j < this.plates.length; j++) {
      if ("新闻动态" == this.plates[j].name) {
        this.plateId = this.plates[j]._id;
        this.$axios
          .get(`/api/articles?plateid=${this.plateId}&sort=-createdAt`)
          .then((res) => {
            if (res.data) {
              this.articles = this.global.sortByTop(res.data.data).slice(0, 5);
              this.$forceUpdate();
              this.$nextTick(function() {});
            }
          });
      }
    }
  },

  watch: {},
};
</script>
<style scoped>
</style>
